<template>
    <v-card 
        height="100%"
        elevation="0"
        class="d-flex flex-column justify-center align-center"
    >
        <v-card-title
            class="d-flex justify-center text-h2"
        >
            {{ `👋🏻 歡迎！`}}
        </v-card-title>

    </v-card>

</template>

<script>

    // import { mapGetters } from 'vuex'

    export default{
        name: 'Home',
        components: {

        },
        data() {
            return {
            }
        },
        async mounted() {
            console.log("HomePage");
        },
        methods: {
        },
        computed: {
        }
    }

</script>